import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_layout/subscriptions/')({
  component: () => <Navigate from="/subscriptions" to="/subscriptions/plan" />,
});
